module.exports = __webpack_public_path__ + "img/Foto-Consulta-de-Fallecidos-700x600.89cf06ed.jpg";